import React from "react";

const OverviewCards = ({ data, summary }) => {
  // Calculate advanced KPIs
  const lateArchivalAnalysis = summary.lateArchivalAnalysis || {};
  const timesheetAnalysis = summary.timesheetAnalysis || {};
  const chargeableHoursAnalysis = summary.chargeableHoursAnalysis || {};
  const headcountAnalysis = summary.headcountAnalysis || {};
  const registers = summary.registers || {};

  // Audit / non-audit split — sourced from the chargeable hours endpoint summary
  const totalAuditHours = chargeableHoursAnalysis.auditHours || 0;
  const totalNonAuditHours = chargeableHoursAnalysis.nonAuditHours || 0;
  const totalHours = totalAuditHours + totalNonAuditHours;

  // Calculate audit and non-audit percentages
  const auditPercentage = totalHours > 0 ? Math.round((totalAuditHours / totalHours) * 100) : 0;
  const nonAuditPercentage = totalHours > 0 ? Math.round((totalNonAuditHours / totalHours) * 100) : 0;

  // Get headcount data - use firm-wide stats for latest year
  const firmWideStats = headcountAnalysis.firmWideStats || {};
  const latestYear = Object.keys(firmWideStats).sort().reverse()[0];
  const currentYearStats = firmWideStats[latestYear] || {};

  const cards = [
    // === LATE ACCOUNTS/ARCHIVAL ISSUES ===
    {
      title: "Late Accounts",
      value: summary.lateAccountsAnalysis?.summaryStats?.totalLateAccounts || data.lateAccounts?.length || 0,
      description: "Accounts requiring attention",
    },
    {
      title: "Late Archival Records",
      value: lateArchivalAnalysis.lateEngagements || 0,
      description: "Archival items requiring attention",
    },
    {
      title: "Late Archival Defaulters",
      value: lateArchivalAnalysis.partnersInvolved || 0,
      description: "Partners with late archival records",
    },

    // === TIMESHEET COMPLIANCE ===
    {
      title: "Timesheet Defaulters",
      value: timesheetAnalysis.uniqueEmployees || 0,
      description: "Unique employees tracked",
    },

    // === WORK HOURS ANALYTICS ===
    {
      title: "Audit Hours",
      value: `${auditPercentage}%`,
      description: "Percentage of total hours",
    },
    {
      title: "Non-audit Hours",
      value: `${nonAuditPercentage}%`,
      description: "Percentage of total hours",
    },

    // === QUALITY REGISTERS ===
    {
      title: "Complaints",
      value: registers.complaints || 0,
      description: "Total complaints recorded",
    },
    {
      title: "Unlocking Requests",
      value: registers.unlocking || 0,
      description: "Archived file unlocking requests",
    },
    {
      title: "EQR Lapses",
      value: registers.eqr || 0,
      description: "Total EQR lapses reported",
    },
    {
      title: "Cyber Incidents",
      value: registers.cyber || 0,
      description: "Cyber security incidents reported",
    },
    {
      title: "A&C Lapses",
      value: registers.ac || 0,
      description: "Acceptance & continuance lapses",
    },

    // === HEADCOUNT ANALYTICS ===
    {
      title: "Total Headcount",
      value: currentYearStats.totalHeadcount || 0,
      description: latestYear ? `As of ${latestYear}` : "No data available",
    },
    {
      title: "Attrition Rate",
      value: currentYearStats.attritionRate ? `${currentYearStats.attritionRate}%` : "N/A",
      description: latestYear ? `${latestYear} annual rate` : "No data available",
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => {
        return (
          <div
            key={index}
            className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm"
          >
            <div>
              <p className="text-sm font-medium text-slate-500">
                {card.title}
              </p>
              <h3 className="text-2xl font-bold text-slate-900">
                {card.value.toLocaleString()}
              </h3>
              <p className="text-xs text-slate-500 mt-1">{card.description}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OverviewCards;
